import type { RouteObject } from 'react-router-dom'

const reportRoute: RouteObject = {
  children: [
    { lazy: () => import('@/pages/report/demography/page'), path: 'demography' },
    { lazy: () => import('@/pages/report/summary/page'), path: 'summary' },
    { lazy: () => import('@/pages/report/job-posting/page'), path: 'job-posting' },
    { lazy: () => import('@/pages/report/vacancy/page'), path: 'vacancy' },
    { lazy: () => import('@/pages/report/candidate/page'), path: 'candidate' },
    { lazy: () => import('@/pages/report/recruitment/page'), path: 'recruitment' },
    { lazy: () => import('@/pages/report/process-analysis/page'), path: 'process-analysis' },
    { lazy: () => import('@/pages/report/process-analysis/detail/Page'), path: 'process-analysis/detail/:id' },
  ],

  path: 'report',
}

export default reportRoute
